import React, { useCallback, useEffect, useState } from 'react';
import events from '../../utils/events';
import Dialog from '../Dialog';
import Text from '../../styled/Text';
import Button from '../../styled/Button';
import { Columns } from '../../styled/Columns/wrappers';
import { Column } from '../../styled/Countdown';
import Distance from '../../styled/Distance';
import { Link } from '../../styled/Link';
import { EV_FETCH_ERROR, FetchError, FetchRequest, get } from '../../api/fetch';
import useContext from '../../hooks/useContext';
import { SiteContext } from '../../SiteContext';

export const TokenValidation = () => {
  const [showModal, setShowModal] = useState(false);
  const {
    data: { isPreview },
  } = useContext(SiteContext);

  useEffect(() => {
    const handleError = (_: FetchRequest, { error, status }: FetchError) => {
      const isTokenValidationException =
        (error as Commerce.CommerceException).type === 'TokenValidationException';

      const isUnauthorized = status === 401;

      if (isTokenValidationException || isUnauthorized) {
        setShowModal(true);
      }
    };

    events.on(EV_FETCH_ERROR, handleError);
    return () => {
      events.off(EV_FETCH_ERROR, handleError);
    };
  }, []);

  const handleClose = useCallback(async () => {
    setShowModal(false);
    await get('/auth/reset');
    window.location.reload();
  }, []);

  if (isPreview || !showModal) {
    return null;
  }

  return (
    <Dialog toggleCloseModal={handleClose} title="En titel">
      {{
        modalTitle: 'Det verkar som du blivit utloggad',
        modalBody: (
          <>
            <Text>Vill du fortsätta vara inloggad?</Text>
            <Distance size="2" />
            <Columns className="align-center">
              <Column>
                <Button tone="ghost" rounded onClick={handleClose}>
                  Nej
                </Button>
              </Column>
              <Column>
                <Link href="/auth/login">
                  <Button rounded tone="forward">
                    Ja, logga in
                  </Button>
                </Link>
              </Column>
            </Columns>
          </>
        ),
      }}
    </Dialog>
  );
};
